import { Reveal } from "@/components/Reveal";
import { SERVICES_DETAIL } from "@/data/services";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-28 lg:py-36 px-5 sm:px-8">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-wrap items-end justify-between gap-8 mb-14 lg:mb-20">
        <Reveal>
          <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-5">Services</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-neutral-50">
            What we do
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="max-w-sm">
          <p className="text-neutral-400 text-sm sm:text-base leading-relaxed">
            Digital experiences designed around your business, your customers and where you want to go next.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {SERVICES_DETAIL.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div
              data-testid={`service-card-${s.n}`}
              className="group relative h-full rounded-2xl border border-white/[0.06] bg-white/[0.02] p-8 transition-[background-color,border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-white/15 hover:bg-white/[0.045]"
            >
              <div className="flex items-start justify-between">
                <span className="w-11 h-11 rounded-lg border border-white/10 flex items-center justify-center text-neutral-400 group-hover:text-neutral-50 group-hover:border-white/25 transition-colors duration-500">
                  <s.icon size={20} strokeWidth={1.5} />
                </span>
                <span className="mono text-xs text-neutral-600 tracking-[0.2em]">{s.n}</span>
              </div>
              <h3 className="font-display text-xl font-semibold text-neutral-100 mt-10">{s.title}</h3>
              <p className="text-sm text-neutral-400 leading-relaxed mt-3">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
